<template>
  <div
    :class="['card-item', { 'card-atrasado': isOverdue }]"
    @click="emitirAbertura(deal)"
  >
    <p class="card-title">
      {{ tituloCard }}
    </p>

    <div
      v-if="hasTags"
      class="card-tags"
    >
      <tag-cartao-proposta :value="deal.etiquetas" />
    </div>

    <div class="card-body">
      <div class="card-info">
        <p v-if="deal.personName">
          <strong>Cliente:</strong> {{ deal.personName || 'Não informado' }}
        </p>
      </div>
    </div>

    <div class="card-footer-expected">
      <div class="card-owner">
        <font-awesome-icon
          :icon="faUser"
          class="mr-1"
          style="font-size: 10px;"
        />
        <span class="owner-name">{{ ownerName }}</span>
      </div>

      <div
        v-if="deal.proposalCount > 0"
        class="card-value-badge"
      >
        <font-awesome-icon
          :icon="faMoneyBillWave"
          class="mr-1"
          style="font-size: 10px;"
        />
        <span>{{ formattedCardValue }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faMoneyBillWave, faUser } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'OportunidadeCard',
  components: {
    FontAwesomeIcon,
    TagCartaoProposta: () => import('@/app-modulo/comercial/proposta/shared/components/tag-cartao-proposta/tag-cartao-proposta.vue'),
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
    isOverdue: {
      type: Boolean,
      default: false,
    },
    formattedValue: {
      type: String,
      default: ' ',
    },
  },
  emits: ['open'],
  data() {
    return {
      faMoneyBillWave,
      faUser,
    }
  },
  computed: {
    hasTags() {
      return Array.isArray(this.deal.etiquetas) && this.deal.etiquetas.length > 0
    },
    tituloCard() {
      return this.deal.companyName || this.deal.personName || 'Não Informado'
    },
    ownerName() {
      if (!this.deal.ownerName || this.deal.ownerName === '') return 'Não definido'
      return this.deal.ownerName
    },
    formattedCardValue() {
      const raw = this.deal?.proposalTotal ?? this.deal?.estimatedValue ?? null
      if (raw === null || raw === undefined || raw === '') return this.formattedValue
      const n = typeof raw === 'string'
        ? Number(String(raw).replace(/\./g, '').replace(',', '.'))
        : Number(raw)
      if (!Number.isFinite(n)) return this.formattedValue
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n)
    },
  },
  methods: {
    emitirAbertura(oportunidade) {
      this.$emit('open', oportunidade)
    },
  },
}
</script>
